// @ts-nocheck
export const SET_MAP_BOUNDS = 'REPORTING_MAP_SET_MAP_BOUNDS';
export const SET_MAP_CENTER = 'REPORTING_MAP_SET_MAP_CENTER';
export const SET_MAP_FIT = 'REPORTING_MAP_SET_MAP_FIT';
export const SET_MAP_TYPE = 'REPORTING_MAP_SET_MAP_TYPE';
export const SET_MAP_ZOOM = 'REPORTING_MAP_SET_MAP_ZOOM';

export const setMapBounds = (id, bounds) => {
  return {
    data: {
      bounds,
      id
    },
    type: SET_MAP_BOUNDS
  };
};
export const setMapCenter = (id, center) => {
  return {
    data: {
      center,
      id
    },
    type: SET_MAP_CENTER
  };
};
export const setMapFit = (id, fit) => {
  return {
    data: {
      fit,
      id
    },
    type: SET_MAP_FIT
  };
};
export const setMapType = (id, type) => {
  return {
    data: {
      id,
      type
    },
    type: SET_MAP_TYPE
  };
};
export const setMapZoom = (id, zoom) => {
  return {
    data: {
      id,
      zoom
    },
    type: SET_MAP_ZOOM
  };
};
